// The theme's primary.main is dark slate with black contrast text, so stock
// primary buttons are unreadable here. Light blue with dark text instead.
export const buttonSx = {
  backgroundColor: "#B0D9E7",
  color: "#0f172a",
  fontWeight: 700,
  border: "1px solid #1e293b",
  "&:hover": { backgroundColor: "#9cc9da" },
  "&.Mui-disabled": {
    backgroundColor: "#e2e8f0",
    color: "#64748b",
    borderColor: "#cbd5e1",
  },
};

export const formatPrice = (value) =>
  value == null
    ? "-"
    : value.toLocaleString("en-US", {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });

export const formatQty = (value) =>
  value.toLocaleString("en-US", { maximumFractionDigits: 0 });

// Human readable list of what the averages cover, shown as chips.
export const describeFilters = (query, filters) => {
  const chips = [];
  if (filters.dateFrom || filters.dateTo) {
    chips.push(
      filters.dateFrom === filters.dateTo
        ? `Date: ${filters.dateFrom}`
        : `Date: ${filters.dateFrom || "start"} to ${filters.dateTo || "today"}`,
    );
  } else {
    chips.push("Date: all time");
  }
  if (query?.trim().length >= 3) chips.push(`Search: ${query.trim()}`);
  if (filters.strategyType) chips.push(`Strategy: ${filters.strategyType}`);
  if (filters.posAction) chips.push(`Action: ${filters.posAction}`);
  if (filters.secType) chips.push(`Type: ${filters.secType}`);
  if (filters.brokerCode) chips.push(`Broker: ${filters.brokerCode}`);
  return chips;
};

export const FILTER_HINT =
  "Search (3+ characters) or choose a Strategy, Action, Security Type or Broker filter first. A date range alone is too broad.";
